/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CreateConditionalIntroductionMessageInput = {
  condition: IntroductionMessageConditionInput;
  content: IntroductionMessageContentInput;
};

export type IntroductionMessageConditionInput = {
  userRegistrationInflowSourceDefinitionGUID: string | number;
};

export type IntroductionMessageContentInput = {
  /** oneof */
  plainIntroductionMessage?: PlainIntroductionMessageInput | null | undefined;
  scenarioChatIntroductionMessage?: ScenarioChatIntroductionMessageInput | null | undefined;
};

export type PlainIntroductionMessageInput = {
  body: string;
  /** 初期チャットメッセージは選択肢なしもあるので、選択肢を消したい・入れたくないときはselectionsに空配列を入れる */
  selections: Array<string>;
};

export type ScenarioChatIntroductionMessageInput = {
  scenarioChatGuid: string | number;
};

export type SettingsPageIntroductionMessageConditionalCreateViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageIntroductionMessageConditionalCreateViewQuery = { viewer: { hasLineActivationProvider: boolean } };

export type CreateConditionalIntroductionMessageMutationVariables = Exact<{
  input: Types.CreateConditionalIntroductionMessageInput;
}>;


export type CreateConditionalIntroductionMessageMutation = { createConditionalIntroductionMessage:
    | { __typename: 'AlreadyExistsConditionalIntroductionMessageError' }
    | { __typename: 'SaveIntroductionMessageSuccess' }
   };


export const SettingsPageIntroductionMessageConditionalCreateViewDocument = gql`
    query SettingsPageIntroductionMessageConditionalCreateView {
  viewer {
    hasLineActivationProvider
  }
}
    `;

/**
 * __useSettingsPageIntroductionMessageConditionalCreateViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageIntroductionMessageConditionalCreateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageIntroductionMessageConditionalCreateViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageIntroductionMessageConditionalCreateViewQuery();
 */
export function useSettingsPageIntroductionMessageConditionalCreateViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables>(SettingsPageIntroductionMessageConditionalCreateViewDocument, {}, options);
}
export function useSettingsPageIntroductionMessageConditionalCreateViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables>(SettingsPageIntroductionMessageConditionalCreateViewDocument, {}, options);
}
export type SettingsPageIntroductionMessageConditionalCreateViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageIntroductionMessageConditionalCreateViewQuery, SettingsPageIntroductionMessageConditionalCreateViewQueryVariables>;
export const CreateConditionalIntroductionMessageDocument = gql`
    mutation createConditionalIntroductionMessage($input: CreateConditionalIntroductionMessageInput!) {
  createConditionalIntroductionMessage(input: $input) {
    __typename
  }
}
    `;

/**
 * __useCreateConditionalIntroductionMessageMutation__
 *
 * To run a mutation, you first call `useCreateConditionalIntroductionMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateConditionalIntroductionMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateConditionalIntroductionMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateConditionalIntroductionMessageMutation(options: VueApolloComposable.UseMutationOptions<CreateConditionalIntroductionMessageMutation, CreateConditionalIntroductionMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateConditionalIntroductionMessageMutation, CreateConditionalIntroductionMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateConditionalIntroductionMessageMutation, CreateConditionalIntroductionMessageMutationVariables>(CreateConditionalIntroductionMessageDocument, options);
}
export type CreateConditionalIntroductionMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateConditionalIntroductionMessageMutation, CreateConditionalIntroductionMessageMutationVariables>;